import { nonNegativeNumber, positiveNumber } from "@/utils/form";
import { ServiceAdvancedCostParametersSchema } from "./ServiceAdvancedCostParameters";
import { z } from "zod";
import { t } from "i18next";

export const EditMobileServiceACPModalSchema = z
  .object({
    name: z.string().min(1, t("schemas:form.required")),
    info: z.string().max(500, t("schemas:form.maxlength", { max: 500 })).optional(),
    hourlyWage: positiveNumber(t("mobileservice.inputs.hourlywage.label")),
    nonTariffAllowance: nonNegativeNumber(
      t("mobileservice.inputs.nontariffallowance.label")
    ),
    acp: ServiceAdvancedCostParametersSchema,
  });

export type TEditMobileServiceACPModalSchema = z.infer<typeof EditMobileServiceACPModalSchema>;
